import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { startSessionRecording, stopSessionRecording } from './mixpanel';

const RESNAPSHOT_DELAY_MS = 300;

export const RouteChangeRecorder = (): null => {
  const { pathname } = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    const timer = setTimeout(() => {
      stopSessionRecording();
      startSessionRecording();
    }, RESNAPSHOT_DELAY_MS);

    return () => clearTimeout(timer);
  }, [pathname]);

  return null;
};
